module.exports = __webpack_public_path__ + "static/media/hollo.e176ea85.gif";